(ns builder.prod
  (:require [builder.core :as core]
            ["@sentry/react" :as sentry]))

(sentry/init
  #js {:dsn                      "https://3b288e1380b14007ff0b03be23301968@o4507417555304448.ingest.us.sentry.io/4508245546762240",
       :release                  (some-> js/window .-aidbox .-about .-version)
       :integrations             [(sentry/browserTracingIntegration)
                                  (sentry/replayIntegration)],
       ; Performance Monitoring
       :tracesSampleRate         1.0,                       ; Capture 100 % of the transactions
       ; Session Replay
       :replaysSessionSampleRate 0.1,                       ; This sets the sample rate at 10 %. You may want to change it to 100 % while in development and then sample at a lower rate in production.
       :replaysOnErrorSampleRate 1.0,})                     ; If you're not already sampling the entire session, change the sample rate to 100 % when sampling sessions where errors occur.})


(defn init []
  (core/init))
